import { UnitTransferUnitsLocationEnumType } from '__generated__/graphql';
import { FC } from 'react';

import { FormInput, FormPanel } from 'components/FormPanel';

import Alert from 'primitives/Alert';

export type UnitsLocationStepData = {
  unitsLocation: UnitTransferUnitsLocationEnumType | '';
};

const StepUnitsLocation: FC<{
  data: UnitsLocationStepData;
  onSubmit: (data: UnitsLocationStepData) => void;
  buttonRef: any;
}> = ({ data, onSubmit, buttonRef }) => {
  return (
    <div>
      <FormPanel loading={false} error={undefined} onSubmit={onSubmit} buttonRef={buttonRef}>
        <FormInput
          fullWidth
          type="radio-group"
          fieldName="unitsLocation"
          label="Where are the units currently held? *"
          defaultValue={data.unitsLocation}
          options={[
            {
              label: 'In my own demat account',
              value: UnitTransferUnitsLocationEnumType.OwnDemat,
            },
            {
              label: 'In the AngelList India Trust escrow account',
              value: UnitTransferUnitsLocationEnumType.AlTrustEscrow,
            },
          ]}
          validators={{ required: true }}
        />
        <FormInput
          fullWidth
          type="custom"
          fieldName="__escrowGuidance"
          label=""
          defaultValue={null}
          conditionsToShow={{
            matches: [
              {
                field: 'unitsLocation',
                condition: '===',
                value: UnitTransferUnitsLocationEnumType.AlTrustEscrow,
              },
            ],
          }}
          customInput={() => (
            <Alert
              type="warning"
              title="Units held in escrow need to move to your own demat"
              message="Before this transfer can proceed, the units currently held in the AngelList India Trust escrow account will typically need to be moved to a demat account in your own name. If opening your own demat account isn't feasible, you can request an escrow-direct exception once our team has moved your request to Under Review — the option appears on the request's tracker page at that point. It needs sign-off from both our operations and legal teams."
            />
          )}
        />
      </FormPanel>
    </div>
  );
};

export default StepUnitsLocation;
